import { lazy, Suspense } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import CookieBanner from "../components/CookieBanner";
import routes from "./config";
import { Styles } from "../styles/styles";

const Router = () => {
  const location = useLocation();
  const isCaja = location.pathname.startsWith("/caja-signa");

  return (
    <Suspense fallback={null}>
      <Styles />
      {!isCaja && <Header />}
      <Switch>
        <Route path="/admin" exact>
          <Redirect to="/" />
        </Route>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
        <Route component={lazy(() => import("../pages/NotFound"))} />
      </Switch>
      {!isCaja && <Footer />}
      {!isCaja && <CookieBanner />}
    </Suspense>
  );
};

export default Router;
